import * as Yup from 'yup';

export const formSchema = Yup.object().shape({

    name: Yup.string().required("Please enter name"),
    apiPath: Yup.string().required("Please enter API path"),
    
})
